import { Component, OnInit, OnDestroy } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { Store } from "@ngrx/store";
import { Actions } from "@ngrx/effects";
import { AppState } from "@store/app-state";
import { Subscription } from "rxjs/Subscription";
import { TransactionsStore } from "@store/transactions";
import { Transaction } from "@models/transaction";
import { DirectDebitSummary } from "@models/direct-debit-summary";
import { FetchTransactionParams, FetchDdsTransactionsParams } from "@services/transaction";
import { FETCH_DDS_TRANSACTIONS, TOGGLE_TRANSACTIONS_CHECKED, POPULATE_TRANSCATIONS, RECHARGE_TRANSACTIONS, RECHARGED_TRANSACTION } from "@reducers/transactions";
import { Contact } from "@models/contact";

interface TransactionsByDebtor {
  debtor: Contact,
  transactions: Transaction[],
}
interface TransactionsByDebtorList extends Array<TransactionsByDebtor>{}

@Component({
  selector: 'transactions-by-debtor-view',
  templateUrl: './transactions-by-debtor-view.pug',
})
export class TransactionsByDebtorViewComponent implements OnInit, OnDestroy {

  private transactionsSubscription: Subscription

  public transactions: Transaction[]
  public transactionsByDebtorList: TransactionsByDebtorList = []
  public dds: DirectDebitSummary
  public viewType: string

  public areAllToggled: boolean = false

  constructor(
    private store: Store<AppState>,
    private route: ActivatedRoute,
    private router: Router,
    private actions: Actions,
  ) {}

  ngOnInit() {
    this.viewType = this.route.snapshot.params["type"]

    this.transactionsSubscription =
      this.store.select("transactionsReducer")
        .subscribe((s: TransactionsStore) => {
          this.transactions   = s.transactions
          this.dds            = s.activeDirectDebitSummary

          this.generateTransactionsByDebtor()
        })
  }

  generateTransactionsByDebtor() {
    if (this.transactionsByDebtorList.length > 0) { return }

    this.transactionsByDebtorList = []

    const uniqueDebtorIds: number[] = []

    this.transactions.forEach((t) => {
      if (uniqueDebtorIds.indexOf(t.debtorId) < 0) {
        uniqueDebtorIds.push(t.debtorId)
      }
    })

    uniqueDebtorIds.forEach((id: number) => {
      const targetTransactions: Transaction[] =
        this.transactions.filter((t: Transaction) => {
          return t.debtorId == id
        })


      const transactionByDebtor: TransactionsByDebtor = {
        debtor: targetTransactions[0].debtor,
        transactions: targetTransactions,
      }

      this.transactionsByDebtorList.push(transactionByDebtor)
    })
  }

  clickedToggleAll() {
    this.areAllToggled = !this.areAllToggled
    this.store.dispatch(
      { type: TOGGLE_TRANSACTIONS_CHECKED, payload: this.areAllToggled })
  }

  isActionsVisible(): boolean {
    return this.viewType == "declined"
  }

  isRechargable(t: Transaction): boolean {
    return t.cycleMetadata.cycleTransactionType == "Declined" &&
      t.cycleMetadata.amountProcessedSince == 0
  }

  areAnyRechargesSelected(): boolean {
    return !!this.transactions.find((t) => t.isChecked && this.isRechargable(t))
  }

  calcAmountToRecharge(t: Transaction): number {
    return t.cycleMetadata.originalAmountToRecover - t.cycleMetadata.amountProcessedSince
  }

  clickedRechargeSelected() {
    this.actions
      .ofType(RECHARGED_TRANSACTION)
      .take(1)
      .subscribe(() => this.router.navigate([
        'direct-debit-summaries',
        this.route.snapshot.params["id"]
      ]))

    const ids = this
      .transactions
      .filter((t) => t.isChecked && this.isRechargable(t))
      .map((t) => t.id)

    this.store.dispatch({ type: RECHARGE_TRANSACTIONS, payload: ids })
  }

  ngOnDestroy() {
    this.transactionsSubscription.unsubscribe()
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/components/transactions-by-debtor-view.ts